module.exports = "pegasus_template/assets/repeat-small.png";